import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { ReEnrollmentsRedux } from '../Redux/ReEnrollmentsRedux'

const reEnrollmentsCrudObservable = createCRUDObservable({
  mainRedux: ReEnrollmentsRedux,
  reduxPath: 're_enrollments',
  dataHandlers: {
    get: response => response.data,
  },
})

export const reEnrollmentsObservers = Object.assign({}, reEnrollmentsCrudObservable.observers, {})

export const reEnrollmentsEpic = combineEpics(
  reEnrollmentsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReEnrollmentsObservable.js